//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const DEPOSITORY_CONTEXT_MENU_SERVICE_NAME = 'depositoryContextMenuService'
export const DEPOSITORY_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'depositoryContextMenuServiceProvider'

export type DepositoryGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: () => void
    onContentEdit?: () => void
    getCorrespondingActionType?: (idReferenceType: Enums.ReferenceType, args: any) => void
}

//#endregion

export class DepositoryContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: DepositoryGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onEdit()
                }
            })
        }

        if (
            _.size(options.idReferenceTypes) === 1
            && options.onContentEdit != null
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_EDIT)
        ) {
            items.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDIT_CONTENT, Enums.SimaxModuleName.Depository),
                    ConfigHelper.Icon.SWAP_HORIZ,
                    this.userSessionService
                ),

                onItemClick: (e: any) => {
                    options.onContentEdit()
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskModule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTasks), ConfigHelper.Icon.TASKS, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdTask, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueMoodule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowIssues), ConfigHelper.Icon.ISSUES, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdIssue, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardModule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowSimCards), ConfigHelper.Icon.SIM_CARD, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdSimCard, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActionModule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowRecentActions), ConfigHelper.Icon.RECENT_ACTIONS, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdAction, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (options.getCorrespondingActionType != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_RUN, Enums.ReferenceType.IdLocation)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions), ConfigHelper.Icon.RUN_ACTIONS, this.userSessionService),

                onItemClick: (e: any) => {
                    options.getCorrespondingActionType(Enums.ReferenceType.IdLocation, e)
                }
            })
        }

        return items
    }

    // #endregion
}

export class DepositoryContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new DepositoryContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
